// extracted by mini-css-extract-plugin
module.exports = {"MainConatiner":"developers-module--MainConatiner--1nu3j","Grid":"developers-module--Grid--BI7f6","DeveloperSec":"developers-module--DeveloperSec--3zvuq"};